import { deviceSelected } from './deviceActions';
import { loadPayload, loadSecondaryPayload } from './payloadActions';
import { selectYourXDropdownToggle } from '../actions/selectYourXDropdownsActions';
import { dropdownIndex } from '../actions/selectYourXIndexActions';


export function routeInit(params, finderTypeId) {
    return function (dispatch) {
        dispatch(loadPayload(params.manufacturer, params.device, finderTypeId));
        dispatch(loadSecondaryPayload());
    };
}